// Constants matching web implementation
export const ACH = 'ach';
export const CARD = 'card';

// Payment method types
export type PaymentMethodType = 'credit_card' | 'debit_card' | 'ach' | 'check' | 'card';

// Fee structure interface matching web API
export interface IPaymentsFeeStructure {
  creditCard: string;
  debitCard: string;
  bankAccount: string;
}


